<!-- 会员资料 -->

<template>
    <div class="lostVip" @click="searchData=[]">
        <div class="tableConBox">
            <div class="tableTem">
                <div class="HSpace1"></div>
                <div class="searchBox flex flex-align-center">
                    <div class="searchCon clearfix">
                        <!-- <span class="left types">
                            会员类型:
                            <el-select v-model="vipType">
                                <el-option
                                  v-for="item in [{value: 'all',label: '全部'},{value: 'lost',label: '流失'}]"
                                  :key="item.value"
                                  :label="item.label"
                                  :value="item.value">
                                </el-option>
                            </el-select>
                        </span> -->
                        <!-- <span class="left" style="color:red;margin-left:20px;">*不勾选默认选择所有会员</span> -->
                        <div class="left search" style="margin-left:20px;">
                            <input type="text" style="padding-left:5px;" v-model="searchPhone" placeholder="请输入会员手机号码." />
                            <!-- <button>查询</button> -->
                            <div class="vip-list-wrap" v-if="searchData.length>0">
                                <div class="vip-list">
                                    <ul>
                                        <li @click="setNowSearchVip(item)" v-for="(item,index) in searchData" :key="index" @mouseenter="nowVipIndex=index" :class="nowVipIndex==index?'active':''">
                                            <span class="name">{{item.name}}</span>
                                            <span class="phone-num right">{{item.mobile}}</span>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <!-- <span class="right sendBtn" @click="PAYcurPage=0;payHost()"><i class="iconfont icon-duanxin"></i>群发记录</span>
                        <span class="right sendBtn" @click="sendWechat"><i class="iconfont icon-weixin"></i>微信群发</span> -->
                        <!-- <span class="right sendBtn"><i class="iconfont icon-duanxin"></i>短信群发</span> -->
                        <span class="right sendBtn" @click="sendCoupon"><i class="iconfont icon--youhuijuanjihuoma"></i>派发优惠卷</span>
                        <span class="right all-amount">会员余额总额：<b>{{(totalAmount).toFixed(2)}}</b></span>
                    </div>
                </div>
                <div class="HSpace2"></div>
                <div class="tableBox">
                    <div class="tableBoxScroll">
                        <table class="titleTable">
                            <tr>
                                <th style="width:6%"><span class="aCheckbox" @click="isAll"><label :class="{show:allCheckArr}"></label></span></th>
                                <th style="width:6%">序号</th>
                                <!-- <th style="width:16%">会员号</th> -->
                                <th style="width:12%">备注名</th>
                                <th style="width:7%"></th>
                                <th style="width:10%">电话</th>
                                <!-- <th style="width:3%"></th> -->
                                <th style="width:10%"><span style="padding-right:5px;">余额</span><i title="点击排序" style="font-size:14px;color:#4a90e2;cursor:pointer;" class="iconfont icon-sanjiaoxing" @click="timeSort=false;addTimeSort=false;getVipData('AMOUNT','DOWN');"></i></th>
                                <th style="width:10%;"><span style="padding-right:5px;">消费时间</span><i title="点击排序" :class="nowTimeSort=='DOWN'?'arrow arrow-back iconfont icon-sanjiaoxing':'arrow iconfont icon-sanjiaoxing'" style="font-size:14px;color:#4a90e2;cursor:pointer;" @click="timeSort=true;addTimeSort=false;nowTimeSort=='DOWN'?nowTimeSort='UP':nowTimeSort='DOWN'"></i></th>
                                <th style="width:12%;"><span style="padding-right:5px;">注册时间</span><i title="点击排序" :class="nowAddTimeSort=='DOWN'?'arrow arrow-back iconfont icon-sanjiaoxing':'arrow iconfont icon-sanjiaoxing'" style="font-size:14px;color:#4a90e2;cursor:pointer;" @click="timeSort=false;addTimeSort=true;nowAddTimeSort=='DOWN'?nowAddTimeSort='UP':nowAddTimeSort='DOWN'"></i></th>
                                <!-- <th style="width:7%">优惠券</th> -->
                                <th style="width:7%">消费详情</th>
                            </tr>
                        </table>
                        <div class="scrollBox">
                            <div class="scroll">
                                <table class="conTable" :class="{overLengthTable:vipData.length>pageSize}">
                                    <tr v-for="(item,ind) in vipData">
                                        <td style="width:6%">
                                            <!-- <input v-if="item.memberId" type="checkbox" id="inventory" v-model="curCheckArr"  :value="item.memberId" style="display:inline-block;width:20px;height:20px;"> -->
                                            <span class="aCheckbox" v-if="item.memberId" style="position: relative;">
                                                <input type="checkbox" :id="'inventory'+ind" v-model="curCheckArr" :value="item.memberId" style="position: absolute;top: 0;left: 0;">
                                                <label :for="'inventory'+ind" :class="{show:item.memberId==curCheckArr[ind]}"></label>
                                            </span>
                                        </td>
                                        <td style="width:6%">
                                            <span v-text="ind+1+pageSize*curPage" v-if="item.memberId"></span>
                                        </td>
                                        <!-- <td style="width:16%" v-text="item.code"></td> -->
                                        <td style="width:12%">
                                            <span v-text="item.memberName"></span>
                                        </td>
                                        <td style="width:7%;text-align:left;">
                                            <i v-if="item.memberId" class="iconfont icon-bianji" style="color:#9FBCFB;cursor:pointer;" @click="notesFn1(item,'name')" :title="'修改备注'"></i>
                                        </td>
                                        <td style="width:10%">
                                            <span v-text="item.mobile"></span>
                                        </td>
                                        <!-- <td style="width:3%">
                                            <i v-if="item.memberId" class="iconfont icon-bianji" style="color:#9FBCFB;cursor:pointer;" @click="notesFn1(item,'mobile')" :title="'修改手机号'"></i>
                                        </td> -->
                                        <td style="width:10%">
                                            <span v-if="item.memberId" v-text="item.amount"></span>
                                        </td>
                                        <td style="width:10%">
                                            <span v-if="item.memberId">{{item.time | numberToMuchDay}}</span>
                                        </td>
                                        <td style="width:12%">
                                            <span v-if="item.memberId">{{item.addTime | numberToMuchDay}}</span>
                                        </td>
                                        <!-- <td style="width:7%"><span v-if="item.memberId" style="color: #3068fe;cursor:pointer;" @click="couponDetail(item)">-查看-</span></td> -->
                                        <td style="width:7%"><span v-if="item.memberId" style="color: #3068fe;cursor:pointer;" @click="vipDetail1(item)">-查看-</span></td>
                                    </tr>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- 分页器 -->
                <div class="pager flex flex-align-center">
                    <div class="left out-excel"><span @click="excel">导出excel</span></div>
                    <div class="pagerCon clearfix">
                        <div class="pagerBtnBox right">
                            <div class="pagerBtn">
                                <span class="prev flex flex-align-center flex-pack-center left" :class="{havePage:(curPage>0)}" @click="changePage(false)"><i class="el-icon-arrow-left"></i></span>
                                <span class="curPageNumber flex flex-align-center flex-pack-center left" v-text="''+(curPage+1)"></span>
                                <span class="next flex flex-align-center flex-pack-center left" :class="{havePage:((curPage+1)<totalPage)}" @click="changePage(true)"><i class="el-icon-arrow-right"></i></span>
                            </div>
                        </div>
                        <div class="curPage flex flex-align-center right" v-text="'第 '+(curPage+1)+' / '+totalPage+' 页'"></div>
                        <div class="totalPage flex flex-align-center right" v-text="'共'+totalElements+'条'"></div>
                    </div>
                </div>
            </div>
        </div>
        <el-dialog
            :title="'派发优惠券'"
            class="coupons"
            :visible.sync="couponBtn"
            v-loading.body="infoload"
            size="tiny">
            <div class="inners">
                <div class="coupon-tip">请选择优惠券:</div>
                <el-select v-model="couponModel">
                    <el-option
                      v-for="item in couponList"
                      :key="item.id"
                      :label="item.title"
                      :value="JSON.stringify(item)">
                    </el-option>
                    <li v-if="couponListMoreBtn" @click="print()" style="color:#999;padding:10px 0;text-align:center;cursor:pointer;"><span>更多优惠券...</span></li>
                </el-select>
                <div class="coupon-tip">请选择优惠券数量:</div>
                <el-select v-model="qty">
                    <el-option
                      v-for="item in qtyOptions"
                      :key="item.title"
                      :label="item.title"
                      :value="item.value">
                    </el-option>
                </el-select>
                <template v-if="!curCheckArr.length">
                    <div class="coupon-tip">请输入密码:</div>
                    <el-input style="width:300px" type="password" v-model="sendPwd" placeholder="请输入密码"></el-input>
                </template>
            </div>
            <div class="coupon-info">
                <div class="coupon-info-item clearfix">
                    <span class="left">优惠卷类型</span>
                    <span class="right" v-text="curCouponData.type?couponType[curCouponData.type]:'-'"></span>
                </div>
                <div class="coupon-info-item clearfix">
                    <span class="left">过期天数</span>
                    <span class="right" v-text="curCouponData.expireDays?curCouponData.expireDays+'天':'-'"></span>
                </div>
                <div class="coupon-info-item clearfix">
                    <span class="left">抵扣商品</span>
                    <span class="right" v-text="curCouponData.productName?curCouponData.productName:'-'"></span>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <button type="button" @click="couponBtn=false" class="cancel">取消</button>
                <button type="button" @click="doShowCoupon" class="save">提交</button>
            </span>
        </el-dialog>
        <el-dialog
            title="消费详情"
            :visible.sync="vipDetailBtn"
            size="tiny">
            <div class="putAllInner">
                <div class="putAllTableBox">
                    <div>
                        <table>
                            <thead>
                                <tr>
                                    <th style="width:20%">序号</th>
                                    <th style="width:20%">时间</th>
                                    <th style="width:20%">流水号</th>
                                    <th style="width:20%">金额</th>
                                    <th style="width:20%">商品</th>
                                </tr>
                            </thead>    
                        </table>
                        <div class="scrollBox">
                            <div class="scroll">
                                <table>
                                    <tbody>
                                        <tr v-for="(item,ind) in vipDetailArr">
                                            <td style="width:20%"><span v-text="ind+1+pageSize*WKcurPage" v-if="item.id"></span></td>
                                            <td style="width:20%"><span >{{item.createTime | numberToDate('')}}</span></td>
                                            <td style="width:20%"><span v-text="item.code"></span></td>
                                            <td style="width:20%"><span v-text="item.amount"></span></td>
                                            <td style="width:20%"><span @click="vipOrderProductDetail(item.items)" v-if="item.id">详情</span></td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
           <div class="pag flex flex-align-center" id="pag">
                <div class="pagerCon clearfix">
                    <div class="pagerBtnBox right">
                        <div class="pagerBtn">
                            <span class="prev flex flex-align-center flex-pack-center left" :class="{havePage:WKcurPage>0}"><i class="el-icon-arrow-left" @click="changeDetailPage(false)"></i></span>
                            <span class="curPageNumber flex flex-align-center flex-pack-center left" v-text="''+(WKcurPage+1)"></span>
                            <span class="next flex flex-align-center flex-pack-center left" ><i class="el-icon-arrow-right" :class="{havePage:((WKcurPage+1)<WKtotalPage)}" @click="changeDetailPage(true)"></i></span>
                        </div>
                    </div>
                    <div class="curPage flex flex-align-center right" v-text="'第 '+(WKtotalElements>0?(WKcurPage+1):'0')+' / '+WKtotalPage+' 页'"></div>
                    <div class="totalPage flex flex-align-center right" v-text="'共'+WKtotalElements+'条'"></div>
                </div>
            </div>
        </el-dialog>
        <el-dialog
            :title="'优惠券详情(已使用：'+usedCount+'张,'+'未使用：'+hasCount+'张)'"
            :visible.sync="showCouponDetail"
            size="tiny">
            <div class="putAllInner">
                <div class="putAllTableBox">
                    <div>
                        <table>
                            <thead>
                                <tr>
                                    <th style="width:20%">序号</th>
                                    <th style="width:20%">优惠券名字</th>
                                    <th style="width:30%">开始时间</th>
                                    <th style="width:30%">过期时间</th>
                                </tr>
                            </thead>    
                        </table>
                        <div class="scrollBox">
                            <div class="scroll" style="height:500px;overflow-y:scroll">
                                <table>
                                    <tbody>
                                        <tr v-for="(item,ind) in couponDetailArr">
                                            <td style="width:20%"><span v-text="ind+1"></span></td>
                                            <td style="width:20%"><span >{{item.title}}</span></td>
                                            <!-- <td style="width:20%"><span >{{item.createTime | numberToDate('')}}</span></td> -->
                                            <td style="width:30%"><span v-text="item.start"></span></td>
                                            <td style="width:30%"><span style="color:#000;" v-text="item.end"></span></td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
           <div class="pag flex flex-align-center" id="pag">
                <!-- <div class="pagerCon clearfix">
                    <div class="pagerBtnBox right">
                        <div class="pagerBtn">
                            <span class="prev flex flex-align-center flex-pack-center left" :class="{havePage:WKcurPage>0}"><i class="el-icon-arrow-left" @click="changeDetailPage(false)"></i></span>
                            <span class="curPageNumber flex flex-align-center flex-pack-center left" v-text="''+(WKcurPage+1)"></span>
                            <span class="next flex flex-align-center flex-pack-center left" ><i class="el-icon-arrow-right" :class="{havePage:((WKcurPage+1)<WKtotalPage)}" @click="changeDetailPage(true)"></i></span>
                        </div>
                    </div>
                    <div class="curPage flex flex-align-center right" v-text="'第 '+(WKtotalElements>0?(WKcurPage+1):'0')+' / '+WKtotalPage+' 页'"></div>
                    <div class="totalPage flex flex-align-center right" v-text="'共'+WKtotalElements+'条'"></div>
                </div> -->
            </div>
        </el-dialog>
        <el-dialog
            title="商品详情"
            :visible.sync="vipOrderProductBtn"
            size="tiny">
            <div class="putAllInner" style="padding:20px 60px 40px;">
                <div class="putAllTableBox">
                    <div>
                        <table>
                            <thead>
                                <tr>
                                    <th style="width:25%">序号</th>
                                    <th style="width:25%">商品名称</th>
                                    <th style="width:25%">数量</th>
                                    <th style="width:25%">合计</th>
                                </tr>
                            </thead>    
                        </table>
                        <div class="scrollBox">
                            <div class="scroll">
                                <table>
                                    <tbody>
                                        <tr v-for="(item,ind) in vipOrderProductArr">
                                            <td style="width:25%"><span v-text="ind+1"></span></td>
                                            <td style="width:25%"><span v-text="item.productName"></span></td>
                                            <td style="width:25%"><span v-text="item.quantity"></span></td>
                                            <td style="width:25%"><span v-text="item.salesPrice"></span></td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </el-dialog>
        <el-dialog
            :title="notes.type=='name'?'备注会员名':'修改手机号'"
            class="codes"
            :visible.sync="notesBtn"
            v-loading.body="infoload"
            size="tiny">
            <div class="inners">
                <input type="text" placeholder="请输入备注" v-model="notes.name" v-if="notes.type=='name'">
                <input type="text" placeholder="请输入电话" v-model="notes.mobile" v-if="notes.type=='mobile'">
            </div>
            <span slot="footer" class="dialog-footer">
                <button type="button" @click="notesBtn=false" class="cancel">取消</button>
                <button type="button" @click="notesFn" class="save">提交</button>
            </span>
        </el-dialog>


        <!-- 确认是否派发优惠券 -->

        <el-dialog
            :title="'确认派发优惠券吗?'"
            class="codes"
            :visible.sync="showSureDistribute"
            v-loading.body="infoload"
            size="tiny">
            <div class="inners" v-if="!curCheckArr || !curCheckArr.length">
                <p>重要提示：确认派发给<b style="color:red;padding: 0 5px;">“所有会员”</b>吗 ？</p>
            </div>
            <div class="inners" v-else>
                <p>确认派发优惠券给所选择的<b style="color:red;padding: 0 5px;">{{curCheckArr.length}}</b>个会员吗 ？</p>
            </div>
            <span slot="footer" class="dialog-footer">
                <button type="button" @click="showSureDistribute=false" class="cancel">取消</button>
                <button type="button" @click="couponUpdate" class="save">确认</button>
            </span>
        </el-dialog>

        <!-- 确认是否派发优惠券结束 -->
        <el-dialog
            title="群发记录"
            :visible.sync="payHostBtn"
            size="tiny">
            <div class="putAllInner" style="padding:20px 60px 40px;">
                <div class="putAllTableBox">
                    <div>
                        <table>
                            <thead>
                                <tr>
                                    <th style="width:20%">序号</th>
                                    <th style="width:20%">充值项目</th>
                                    <th style="width:20%">会员数量</th>
                                    <th style="width:20%">充值时间</th>
                                    <th style="width:20%">金额</th>
                                </tr>
                            </thead>    
                        </table>
                        <div class="scrollBox">
                            <div class="scroll">
                                <table>
                                    <tbody>
                                        <tr v-for="(item,ind) in payHostArr">
                                            <td style="width:20%"><span v-text="ind+1"></span></td>
                                            <td style="width:20%"><span v-text="item.type=='WECHAT'?'微信群发':'-'"></span></td>
                                            <td style="width:20%"><span v-text="item.qty"></span></td>
                                            <td style="width:20%"><span >{{item.updateTime | numberToMonthDate('')}}</span></td>
                                            <td style="width:20%"><span v-text="item.amount/100"></span></td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="pag flex flex-align-center" id="pag">
                <div class="pagerCon clearfix">
                    <div class="pagerBtnBox right">
                        <div class="pagerBtn">
                            <span class="prev flex flex-align-center flex-pack-center left" :class="{havePage:PAYcurPage>0}"><i class="el-icon-arrow-left" @click="payHostPage(false)"></i></span>
                            <span class="curPageNumber flex flex-align-center flex-pack-center left" v-text="''+(PAYcurPage+1)"></span>
                            <span class="next flex flex-align-center flex-pack-center left" ><i class="el-icon-arrow-right" :class="{havePage:((PAYcurPage+1)<PAYtotalPage)}" @click="payHostPage(true)"></i></span>
                        </div>
                    </div>
                    <div class="curPage flex flex-align-center right" v-text="'第 '+(PAYtotalElements>0?(PAYcurPage+1):'0')+' / '+PAYtotalPage+' 页'"></div>
                    <div class="totalPage flex flex-align-center right" v-text="'共'+PAYtotalElements+'条'"></div>
                </div>
            </div>
        </el-dialog>
        <div class="weChatOuter" v-if="weChatBtn" @click="weChatBtn = false">
            <div class=" position-middle-center clearfix" style="width:720px;" @click.stop="" v-if="seep==1" >
                <div class="wx-box left">
                    <div class="title">微信群发<span class="title-notes">每条0.05元</span><div class="title-close-btn" @click="weChatBtn = false">&times;</div></div>
                    <div class="wx-content">
                        <div class="wx-cont-item">
                            <span class="span">网吧</span>
                            <input class="input" type="text" placeholder="请输入店铺名称" v-model="weChatModel.name">
                        </div>
                        <div class="wx-cont-item">
                            <span class="span">主题</span>
                            <input class="input" type="text" placeholder="请输入活动主题（8-14字为佳）" v-model="weChatModel.ACtitle">
                        </div>
                        <div class="wx-cont-item">
                            <span class="span">时间</span>
                            <el-date-picker
                                class="time"
                                :editable='false'
                                v-model="weChatModel.timeFrom"
                                :picker-options="pickerOptions0"
                                type="date"
                                placeholder="请输入开始时间">
                            </el-date-picker>
                            <span>至</span>
                             <el-date-picker
                                class="time"
                                v-model="weChatModel.timeTo"
                                :editable='false'
                                :picker-options="pickerOptions0"
                                type="date"
                                placeholder="请输入结束时间">
                            </el-date-picker>
                        </div>
                        <div class="wx-cont-item">
                            <span class="span">地址</span>
                            <input class="input" type="text" placeholder="请输入活动地址" v-model="weChatModel.address">
                        </div>
                        <div class="wx-cont-item">
                            <span class="span" style="position:relative;top:-90px">内容</span>
                            <textarea name="" id=""  v-model="weChatModel.rules" placeholder="请输入活动内容或规则"></textarea>
                        </div>
                        <div class="wx-cont-item">
                            <span class="span">背景</span>
                            <span :class="['bgType',{AC_BG:curBgIndex==ind}]"  v-for="(item,ind) in bgArr"  v-text="'背景'+(ind+1)" @click="cutBg(item,ind)"></span>
                        </div>
                    </div>
                    <div class="wx-footer clearfix">
                        <div class="left" style="margin-left:20px;"><p  v-text="'会员总数：'+payData.memberCount"></p><p style="margin-top:5px;color:red;" v-text="'费用：'+payData.amount/100+'元'"></p></div>
                        <div class="right "><button type="button" class="sure" @click="wxUP">提交</button></div>
                        <div class="right "><button type="button" class="cancle" @click="weChatBtn = false">取消</button></div>
                    </div>
                </div>
                <div class="right shell-box">
                    <div class="shell-box-topBG">
                    </div>
                    <div class="shell-box-innerBg" id="shell-box-innerBg">
                    </div>
                    <div class="shell-box-innerCont">
                        <div class="shell-name" v-text="weChatModel.name"></div>
                        <div class="shell-title" v-text="weChatModel.ACtitle"></div>
                        <div class="shell-time">
                            <span v-text="new Date(weChatModel.timeFrom).Format('yyyy.MM.dd')" v-if="new Date(weChatModel.timeFrom).getTime()==new Date(weChatModel.timeTo).getTime()"></span>
                            <span v-else v-text="new Date(weChatModel.timeFrom).Format('yyyy.MM.dd')+'-'+new Date(weChatModel.timeTo).Format('yyyy.MM.dd')"></span>
                        </div>
                        <div class="shell-rules-title">活动规则</div>
                        <div class="shell-rules-cont" v-html="weChatShowRules"></div>
                        <div class="shell-addr" v-text="'地址：'+weChatModel.address"></div>
                    </div>
                </div>
            </div>
            <!-- 支付二维码 -->
            <div class="pay position-middle-center" v-if="seep==2" 
            style="width:300px;height:310px;background:#fff;border-radius:5px;" @click.stop="">
                <div class="imgbox" style="width:300px;height:20px;position:relative;text-align:center;font-size:18px;margin-top:10px;">
                    请用微信扫码支付
                    <span style="position:absolute;right:2px;top:-5px;;font-size:24px;right:5px;cursor:pointer;" @click="closePay">&times;</span>
                </div>
                <img :src="payUrl" alt="" style="width:300px;height:300px;">
            </div>
        </div>
     <table id="scrollBox" style="display:none"></table> 
    </div>
</template>

<script type="text/javascript">
    import {url} from '@/router/url.js';
    import {API_BASE_URL} from "./../../../urlConfig/index";
    export default{
        props:['curStoreId', 'pageSize','storeData'],
    	data () {
    		return {
                sendPwd:"",
                nowAddTimeSort:"DOWN",
                canClick:true,
                qty:1,
                qtyOptions:[
                ],
                pageSize:10,
                timeSort:false,
                addTimeSort:false,
                nowTimeSort:"DOWN",
                totalAmount:0,//会员总金额
                nowVipIndex:0,
                searchPhone:"",
                searchData:[],
                couponCount:0,//优惠券总数量
                usedCount:0,//已使用数量
                hasCount:0,//未使用数量
                couponDetailArr:[],//优惠券详情
                showCouponDetail:false,
                pickerOptions0: {
                    disabledDate(time) {
                        return time.getTime() < Date.now()-24*3600000 ;
                    }
                },
                showSureDistribute:false,
                vipOrderProductArr:[],
                vipOrderProductBtn:false,
                dialogVisible: false,
                vipData:[],//会员数据
                vipDataLength:0,
                curCheckArr:[],//当前选择的
                allCheckArr:false,//全选所有
                couponList:[],
                couponType:{
                    'GET_ITEM_FREE':'商品抵用券',
                    'REDUCE':'代金券',
                },
                couponModel:'',//当前优惠券模型
                curCouponData:'',//当前优惠券
                curCouponPage:0,//下拉框中当前优惠券的页码
                couponListMoreBtn :false,//下拉框中是否有更多优惠券

                curPage: 0,//当前页，用于切换页码
                totalPage: 1,//总共页
                totalElements: 0,//总共条
                vipType:'all',//会员类型
                couponBtn:false,//优惠券派发弹出框
                weChatBtn:false,//微信群发弹出框
                payHostBtn:false,//充值历史记录
                payHostArr:[],
                infoload:false,
                
                vipDetailArr:[],//消费详情数据
                vipDetailBtn:false,
                memberDetailId:'',//某会员id
                WKcurPage: 0,//消费详情当前页，用于切换页码
                WKtotalPage: 1,//消费详情总共页
                WKtotalElements: 0,//消费详情总共条

                PAYcurPage: 0,//消费详情当前页，用于切换页码
                PAYtotalPage: 1,//消费详情总共页
                PAYtotalElements: 0,//消费详情总共条

                notesBtn:false,//
                notes:{
                    name:'',
                    mobile:'',
                    type:'name'
                },
                clickBtn:true,
                weChatModel:{
                    name:'',
                    ACtitle:'',
                    timeFrom:'',
                    timeTo:'',
                    address:'',
                    rules:'',
                    BG:''
                },
                weChatShowRules:'',
                payUrl:'',
                payTimer:'',
                payData:{},
                curBgIndex:0,
                bgArr:[
                    'https://images.huoxingy.com/image/f6706240-7f24-11e7-8738-6539b23612c0/53fd6f57d35c4e07a68e41a16d4f6369.jpg',
                    'https://images.huoxingy.com/image/f6706240-7f24-11e7-8738-6539b23612c0/e1fb020b84f3466eb48db9a3fb56b7f4.jpg',
                    'https://images.huoxingy.com/image/f6706240-7f24-11e7-8738-6539b23612c0/341a0335c4604ba4977411ce60750c76.jpg',
                    'https://images.huoxingy.com/image/f6706240-7f24-11e7-8738-6539b23612c0/8b51e5f483de483d86154d1978011b0d.jpg',
                    'https://images.huoxingy.com/image/f6706240-7f24-11e7-8738-6539b23612c0/9b708dc5d64d474c87e63b0d5bb78987.jpg',
                    'https://images.huoxingy.com/image/f6706240-7f24-11e7-8738-6539b23612c0/1b4b2e7e39574f1584e713b19367426c.jpg',
                    'https://images.huoxingy.com/image/f6706240-7f24-11e7-8738-6539b23612c0/6242fe1ef1be48899959caf05f27898d.jpg'
                ],
                seep:1
    		}
    	},
        watch:{
            'weChatModel.rules':function(val){
                this.weChatShowRules = '';
                let oldCode = encodeURI(val);
                let arr=oldCode.split('%0A');
                for (var i = 0,len=arr.length; i < len; i++) {
                   this.weChatShowRules+=("<p style='margin:5px 0;'>"+ decodeURI(arr[i])+"</p>");
                }
            },
            vipType(val){
                this.curPage = 0;
                this.curCheckArr = [];
                this.getVipData("AMOUNT","DOWN")
            },
            couponModel( val ) {
                this.curCouponData = JSON.parse(val);
            },
            curCheckArr(val){
                if(this.vipDataLength>0){
                    if(val.length>=this.vipDataLength){
                        this.allCheckArr = true;
                    }else {
                        this.allCheckArr = false;
                    }
                }
            },
            searchPhone(val){
                if(!val){
                    this.searchData = [];
                    this.getVipData("AMOUNT","DOWN");
                    return;
                }
                this.searchVip();
            },
            nowTimeSort(val){
                this.getVipData("TIME",val);
            },
            nowAddTimeSort(val){
                this.getVipData("addTime",val);
            },
            couponBtn(val){
                if(!val){
                    this.couponList = [];
                    this.curCouponPage = 0;
                    this.qty = 1;
                }
            }
        },
        methods: {
            //导出按钮
            excel(){
                this.$http({
                    url:this.curStoreId+'/member',
                    method:"GET",
                    params:{
                      page:0,
                      pageSize:100000,
                      type:this.vipType,
                      source:"AMOUNT",
                      direction:this.nowTimeSort,
                    }
                }).then(res=>{
                    let data = res.data.data;
                    console.log(data)
                    let html = '<tr>'+  
                                '<td style="font-size:18px">会员备注名</td>'+
                                '<td style="font-size:18px">电话</td>'+
                                '<td style="font-size:18px">余额</td>'+ 
                                '<td style="font-size:18px">最后一次消费时间</td>'+ 
                            '</tr>';
                        for(var i=0;i<data.length;i++){
                            if ( !data[i].memberId ) {
                                continue;
                            }
                            html  +='<tr>'+
                                        '<td>'+data[i].memberName+'</td>'+
                                        '<td>'+data[i].mobile+'</td>'+ 
                                        '<td>'+data[i].amount+'</td>'+ 
                                        '<td>'+this.toOtherDay(data[i].time)+'</td>'+ 
                                    '</tr>';
                        }
                        console.log(document.getElementById('scrollBox'))
                    document.getElementById('scrollBox').innerHTML = html;
                    window.method5(scrollBox);
                });
            },
            toOtherDay:function ( val ) {
                if ( !val ) {
                    return '';
                }
                let dateArr = val.split('.');
                let dateStr = dateArr[0];
                let date = new Date(dateStr.replace(/-/g,"/")).getTime();
                let nowDate = new Date().getTime();
                let timeStr = nowDate - date;
                let oneDay = 1000*60*60*24;
                let day = Math.floor(timeStr / oneDay);
                let hours=Math.floor((timeStr % oneDay)/(3600*1000))
                if(day > 0){
                    return day + "天前";
                }else{
                    return "今天";
                }
            },
            setNowSearchVip(item){
                this.searchData = [];
                this.vipData = [];
                this.totalAmount = item.amount;
                this.vipDataLength = 1;
                this.totalElements = 1;
                this.totalPage = 1;
                this.vipData.push({
                    "id": item.id,
                    "memberId": item.id,
                    "memberName": item.name,
                    "storeId": '',
                    "code": item.code,
                    "referralMemberId": '',//推荐人id
                    "mobile": item.mobile,//推荐人name
                    "frequency": '',//频次
                    "allFrequency": '',//总次数
                    "amount": item.amount,//金额
                });
                for(let i = 1, len = 10; i < len; i++){
                    this.vipData.push({
                        "id": '',
                        "memberId": '',
                        "memberName": '',
                        "storeId": '',
                        "code": '',
                        "referralMemberId": '',//推荐人id
                        "mobile": '',//推荐人name
                        "frequency": '',//频次
                        "allFrequency": '',//总次数
                        "amount": '',//金额
                    })
                }
            },
            searchVip(){
                this.$http({
                    url:API_BASE_URL+"v1/pos/members",
                    method:"GET",
                    params:{
                       storeId: this.curStoreId,
                       q: this.searchPhone
                    }
                }).then(res=>{
                    this.searchData = res.data;
                });
            },
            couponDetail(item){
                this.getCouponList(item);
                this.showCouponDetail = true;
            },
            getCouponList(item){
                this.$http({
                    url:"get-coupon",
                    method:"GET",
                    params:{
                        storeId:this.curStoreId,
                        memberId:item.memberId
                    }
                }).then(res=>{
                    this.couponDetailArr = res.data.res;
                    this.usedCount = res.data.use;
                    this.hasCount = res.data.has;
                });
            },
            // 显示是否打开派发优惠券弹窗
            doShowCoupon(){
                if(!this.curCouponData){
                    this.$message({
                        message: '请选择会员券',
                        customClass: 'error'
                    })
                    return;
                }
                if(!this.curCheckArr.length){
                    if(!String(this.sendPwd).trim()){
                        this.$message({
                            message: '请输入密码',
                            customClass: 'error'
                        });
                        return;
                    }
                    let pwd = new Base64();
                    let pwdStr = 'hxbs 123.999'+ pwd.encode(this.sendPwd);
                    this.$http({
                        url:"judge-psw",
                        method:"POST",
                        data:{
                            storeId:this.curStoreId,
                            judgePsw:pwdStr
                        }
                    }).then(res=>{
                        if(res.data.code == 400){
                            this.$message({
                                message: res.data.msg,
                                showClose: true,
                                customClass: 'error'
                            });
                            return; 
                        }else if(res.data.code == 200){
                            this.showSureDistribute = true;
                        }
                    })
                    return;
                }
                this.showSureDistribute = true;
            },
            //充值记录
            payHost(){
                this.$http.get(this.curStoreId+'/store-orders'+'?page='+this.PAYcurPage+'&pageSize='+this.pageSize).then((res)=>{
                    this.payHostBtn = true;
                    this.payHostArr = res.data.content;
                    this.PAYtotalElements = res.data.totalElements
                    this.PAYtotalPage = res.data.totalPages
                })
            },
            //点击全选
            isAll(){
                if(this.allCheckArr){
                    this.allCheckArr = false;
                    this.curCheckArr = [];
                }else{
                    this.allCheckArr = true;
                    for (var i = this.vipData.length - 1; i >= 0; i--) {
                        if(this.vipData[i].memberId){
                            this.curCheckArr.push(this.vipData[i].memberId)
                        }
                    }
                }
            },
            //下拉框中是否有更多优惠券
            print: function () {
                this.curCouponPage++;
                this.sendCoupon();
            },
            //列表翻页
            payHostPage: function ( boo ) {
                if(!this.clickBtn){
                    return;
                }
                this.clickBtn = false;
                setTimeout(()=>{
                     this.clickBtn = true;
                },800)
                if ( boo ) {
                    if ( (this.PAYcurPage + 1) >= this.PAYtotalPage ) {
                        return;
                    }
                    this.PAYcurPage++;
                } else {
                    if ( this.PAYcurPage <= 0 ) {
                        return;
                    }
                    this.PAYcurPage--;
                }
                this.payHost();
            },//列表翻页
            changePage: function ( boo ) {
                if(!this.clickBtn){
                    return;
                }
                this.clickBtn = false;
                this.curCheckArr = [];
                this.allCheckArr = false;
                setTimeout(()=>{
                     this.clickBtn = true;
                },800)
                if ( boo ) {
                    if ( (this.curPage + 1) >= this.totalPage ) {
                        return;
                    }
                    this.curPage++;
                } else {
                    if ( this.curPage <= 0 ) {
                        return;
                    }
                    this.curPage--;
                }
                if(this.timeSort){
                    this.getVipData("TIME",this.nowTimeSort);
                }else if(this.addTimeSort){
                    this.getVipData("addTime",this.nowAddTimeSort);
                }else{
                    this.getVipData("AMOUNT","DOWN");
                }
            },
            //明细翻页
            changeDetailPage: function ( boo ) {
                if(!this.clickBtn){
                    return;
                }
                this.clickBtn = false;
                setTimeout(()=>{
                     this.clickBtn = true;
                },800)
                if ( boo ) {
                    if ( (this.WKcurPage + 1) >= this.WKtotalPage ) {
                        return;
                    }
                    this.WKcurPage++;
                } else {
                    if ( this.WKcurPage <= 0 ) {
                        return;
                    }
                    this.WKcurPage--;
                }
                this.vipDetail();
            },
            //发券
            couponUpdate(){
                if(!this.curCouponData){
                    this.$message({
                        message: '请选择会员券',
                        customClass: 'error'
                    })
                    return;
                }
                // if(!this.curCheckArr.length){
                //     this.$message({
                //         message: '请选择会员',
                //         customClass: 'error'
                //     })
                //     return;
                // }
                if(!this.canClick){
                    return;
                }
                this.canClick = false;
                let type='';
                if(this.vipType=='all'){
                    type=this.curCheckArr.length==0?'ALL':"SINGLE"
                }else if(this.vipType=='lost'){
                    type=this.curCheckArr.length==0?'SLEEP':"SINGLE"
                }
                let body = {
                    storeId : this.curStoreId,
                    couponId : this.curCouponData.id,
                    distributeType : type,
                    memeberIds : this.curCheckArr,
                    qty:this.qty
                }
                this.$http.post('distribute-coupon',body).then((res)=>{
                    setTimeout(()=>{
                        this.canClick = true;
                    },1000);
                    this.couponBtn=false;
                    this.curCouponPage = 0;
                    this.curCouponData = {};
                    this.$message({
                        message: '操作成功',
                        customClass: 'success'
                    })
                    this.curCheckArr = [];
                    this.showSureDistribute = false;
                }).catch(err=>{
                    setTimeout(()=>{
                        this.canClick = true;
                    },1000);
                })
            },
            //发券  // 获取优惠券列表
            sendCoupon(){
                if(this.vipDataLength<=0){
                    this.$message({
                        message: '暂无会员可派发优惠券',
                        customClass: 'error'
                    })
                    return;
                }
                this.couponModel = '';
                this.$http.get('coupon/list?storeId='+this.curStoreId+'&page='+this.curCouponPage+'&pageSize='+this.pageSize).then((res)=>{
                     this.couponList = this.couponList.concat(res.data.content);

                    if(res.data.content.length>=10){
                        this.couponListMoreBtn = true;
                    }else{
                        this.couponListMoreBtn = false;
                    }
                    this.couponBtn=true;
                    this.curCouponData='';
                }).catch(()=>{

                })
            },
            //微信群发
            sendWechat(){
                this.weChatBtn = true;
                this.curBgIndex = 0;
                this.$http.get('estimate/store-orders?storeId='+this.curStoreId).then((res)=>{
                    this.payData = res.data;
                })
                this.weChatModel={
                    name:this.storeData.name,
                    ACtitle:'',
                    timeFrom:new Date(),
                    timeTo:new Date(),
                    address:this.storeData.addr,
                    rules:'',
                    BG:''
                }
            },
            //关闭微信群发支付弹框
            closePay(){
                clearInterval(this.payTimer)
                this.seep = 1;
                this.weChatBtn = false;
            },
            //切换背景
            cutBg(item,ind){
                this.curBgIndex = ind;
                $('#shell-box-innerBg').css('background-image','url('+item+')')
            },
            //微信群发
            wxUP(){
                this.weChatModel.name = this.weChatModel.name.replace(/(^\s*)|(\s*$)/g, "");
                if(!this.weChatModel.name){
                    this.$message({
                        message: '请输入店铺名称',
                        customClass: 'error'
                    })
                    return;
                }
                this.weChatModel.ACtitle = this.weChatModel.ACtitle.replace(/(^\s*)|(\s*$)/g, "");
                if(!this.weChatModel.ACtitle){
                    this.$message({
                        message: '请输入活动主题',
                        customClass: 'error'
                    })
                    return;
                }
                this.weChatModel.address = this.weChatModel.address.replace(/(^\s*)|(\s*$)/g, "");
                if(!this.weChatModel.address){
                    this.$message({
                        message: '请输入店铺地址',
                        customClass: 'error'
                    })
                    return;
                }
                this.weChatModel.rules = this.weChatModel.rules.replace(/(^\s*)|(\s*$)/g, "");
                if(!this.weChatModel.rules){
                    this.$message({
                        message: '请输入活动内容或规则',
                        customClass: 'error'
                    })
                    return;
                }
                if(new Date(this.weChatModel.timeFrom).getTime()>new Date(this.weChatModel.timeTo).getTime()){
                    this.$message({
                        message: '活动开始时间应小于结束时间!',
                        customClass: 'error'
                    })
                    return;
                }
                let oldCode = encodeURI(this.weChatModel.rules);
                let arr=oldCode.split('%0A');
                let contentCode = '';
                let viceContentCode = '';
                for (var i = 0,len=arr.length; i < len; i++) {
                   viceContentCode+=('<p>'+ decodeURI(arr[i])+'</p>');
                   contentCode+=(decodeURI(arr[i])+'\n');
                }
                let body={
                    id:this.$uuid.create(1).hex,
                    storeId:this.curStoreId,
                    storeName:this.weChatModel.name,
                    theme:this.weChatModel.ACtitle,//主题
                    time:new Date(this.weChatModel.timeFrom).Format('yyyy.MM.dd')+'-'+new Date(this.weChatModel.timeTo).Format('yyyy.MM.dd'),//时间
                    address:this.weChatModel.address,
                    content:contentCode,
                    viceContent:viceContentCode,
                    contextUrl:this.bgArr[this.curBgIndex]
                }
                this.$http.post('wechat-send-template',body).then((res)=>{
                    this.$message({
                        message: '提交成功，请及时支付！',
                        customClass: 'success'
                    })
                    this.payUrl = res.data.url;
                    this.seep = 2;
                    this.payTimer = setInterval(()=>{
                        this.$http.get('query/store-orders?id='+res.data.id).then((ress)=>{

                            if(ress.status==200){
                                clearInterval(this.payTimer)
                                this.$message({
                                    message: '支付成功！',
                                    customClass: 'success'
                                })
                                this.seep = 1;
                                this.weChatBtn = false;
                            }
                        }).catch((err)=>{
                            clearInterval(this.payTimer)
                        })
                    },2000)
                })
            },
            //修改备注
            notesFn1(item,type){
                if(type=='name'){
                    this.notes.name = item.name;
                    this.notes.mobile = '';
                }else if(type=='mobile'){
                    this.notes.mobile = item.mobile;
                    this.notes.name = '';
                }
                this.notes.type = type;
                this.notesBtn = true;
                this.memberDetailId = item.memberId;
            },
            //修改备注
            notesFn(){
                if(this.notes.type == 'mobile'  ){
                    if ( !(/^1[3|4|5|7|8][0-9]{9}$/.test(this.notes.mobile)) ) {
                        this.$message({
                            message:"请输入正确的手机号",
                            customClass: "error"
                        });
                        return;   
                    }
                }
                if(this.notes.type == 'name'  ){
                    this.notes.name = this.notes.name.replace(/(^\s*)|(\s*$)/g, "");
                    if ( !this.notes.name ) {
                        this.$message({
                            message:"名字格式不对",
                            customClass: "error"
                        });
                        return;   
                    }
                }
                let body = {
                    storeId:this.curStoreId,
                    memberId:this.memberDetailId,
                    name:this.notes.name,
                    mobile:this.notes.mobile
                }
                this.$http.post('remark-member',body).then((res)=>{
                     this.notesBtn = false;
                    this.notes.name = '';
                    this.notes.mobile = '';
                    this.curPage = 0;
                    if(this.timeSort){
                        this.getVipData("TIME",this.nowTimeSort);
                    }else if(this.addTimeSort){
                        this.getVipData("addTime",this.nowAddTimeSort);
                    }else{
                        this.getVipData("AMOUNT","DOWN");
                    }
                })
            },
            //查看会员商品数据
            vipOrderProductDetail(item){
                this.vipOrderProductArr = item;
                this.vipOrderProductBtn = true;
            },
             //获取会员详情  数据
            vipDetail(){
                this.vipDetailArr = [{},{},{},{},{},{},{},{},{},{}];
                this.$http.get('/member-sales?storeId='+this.curStoreId+'&page='+this.WKcurPage+'&pageSize='+this.pageSize+'&memberId='+this.memberDetailId).then((res)=>{
                    this.vipDetailArr = res.data.content;
                    this.WKtotalPage = res.data.totalPages;
                    this.WKtotalElements = res.data.totalElements;
                    this.vipDetailBtn = true;
                    if( this.vipDetailArr.length < this.pageSize ){
                        for(let i = 0, len = this.pageSize - this.vipDetailArr.length; i < len; i++){
                            this.vipDetailArr.push({})
                        }
                    }
                 }).catch((res)=>{
                 })
            },
            //获取会员详情memberId
            vipDetail1(item){
                this.WKcurPage = 0;
                this.memberDetailId = item.memberId;
                this.vipDetail();
            },
            //获取会员资料
            getVipData(source,direction){
                this.vipData = [{},{},{},{},{},{},{},{},{},{}];

                this.$http({
                    url:this.curStoreId+'/member',
                    method:"GET",
                    params:{
                      page:this.curPage,
                      pageSize:10,
                      type:this.vipType,
                      source,
                      direction,
                    }
                }).then(res=>{
                    // this.vipData = res.data.consumptions;
                    this.totalAmount = res.data.amount;
                    this.vipData = res.data.data;
                    // this.vipDataLength = res.data.consumptions.length;
                    this.vipDataLength = res.data.data.length;
                    this.totalElements = res.data.totalElements;
                    this.totalPage = res.data.totalPages;
                    for(let i = 0, len = this.vipData.length; i < len; i++){
                        this.vipData[i].amountBonus =  (this.vipData[i].bonus+this.vipData[i].amount).toFixed(2)
                    }
                    if( this.vipData.length < this.pageSize ){
                        for(let i = 0, len = this.pageSize - this.vipData.length; i < len; i++){
                            this.vipData.push({
                                "id": '',
                                "memberId": '',
                                "memberName": '',
                                "storeId": '',
                                "code": '',
                                "referralMemberId": '',//推荐人id
                                "mobile": '',//推荐人name
                                "frequency": '',//频次
                                "allFrequency": '',//总次数
                                "amount": '',//金额
                            })
                        }
                    }
                })


                // this.$http.get(this.curStoreId+'/member?page='+this.curPage+'&type='+this.vipType).then((res)=>{
                //     // this.vipData = res.data.consumptions;
                //     this.totalAmount = res.data.amount;
                //     this.vipData = res.data.data;
                //     // this.vipDataLength = res.data.consumptions.length;
                //     this.vipDataLength = res.data.data.length;
                //     this.totalElements = res.data.totalElements;
                //     this.totalPage = res.data.totalPages;
                //     for(let i = 0, len = this.vipData.length; i < len; i++){
                //         this.vipData[i].amountBonus =  (this.vipData[i].bonus+this.vipData[i].amount).toFixed(2)
                //     }
                //     if( this.vipData.length < this.pageSize ){
                //         for(let i = 0, len = this.pageSize - this.vipData.length; i < len; i++){
                //             this.vipData.push({
                //                 "id": '',
                //                 "memberId": '',
                //                 "memberName": '',
                //                 "storeId": '',
                //                 "code": '',
                //                 "referralMemberId": '',//推荐人id
                //                 "mobile": '',//推荐人name
                //                 "frequency": '',//频次
                //                 "allFrequency": '',//总次数
                //                 "amount": '',//金额
                //             })
                //         }
                //     }
                // })
            }
        },
        created: function () {
            console.log(this.storeData)
            for (var i = 0; i < this.pageSize; i++) {
                this.vipData.push({});
            }
        },
        activated: function () {
            if(this.$route.params.type=='LOST'){
                this.vipType = 'lost';
            }
            let qtyOptions = [];
            for(let i=0;i<30;i++){
                let obj = {
                    title:`${i+1}张`,
                    value:i+1
                }
                qtyOptions.push(obj);
            }
            this.qtyOptions = qtyOptions;
            this.getVipData("AMOUNT","DOWN");
        }
    }
</script>
<style lang="scss">
    @import '../../../../static/css/common.scss';
    @import '../../tableTemplate/tableTem.scss';
    @import '../../tableTemplate/el-dialog.scss';
	@import "lostVip";
</style>



// WEBPACK FOOTER //
// lostVip.vue?c8162448